export default __webpack_public_path__ + "static/media/fort-mojave-indian-tribe.21168820.png";